import {LOADING_KEY_PREFIX, PromptFilterId} from '@Panels/ai-voice-panel/ai-voice-panel.types';

export const getIconForPromptFilter = (filterId: PromptFilterId): string => {
  switch (filterId) {
    case PromptFilterId.VOICE:
      return 'icon-voice-profile';
    default:
      throw new Error(`Unhandled prompt filter id for ai voice: ${filterId}`);
  }
};

export const getLoadingKeyForAiVoice = (panelId: string): string => {
  return `${LOADING_KEY_PREFIX}-${panelId}`;
};
